import { Component, ViewChild } from '@angular/core';
import { RecurrentTourListComponent } from './recurrent-tour-list.component';

@Component({
  selector: 'app-recurrent-tour',
  template: `
    <section id="left-content">
      <app-recurrent-tour-list (tourTemplateSelected)="onTourTemplateSelected($event)"></app-recurrent-tour-list>
    </section>
    <section id="right-content">
      <app-recurrent-tour-form [tourTemplate]="tourTemplate" (tourTemplateSaved)="onTourTemplateSaved($event)"></app-recurrent-tour-form>
    </section>
  `,
  styles: [`
    :host {
      height: 100%;
      display: -ms-flexbox;
      display: flex;
      -ms-flex: 1 1 0px;
      flex: 1 1 0px;
      overflow: hidden;
    }
    #left-content {
      -ms-flex: 0 0 33%;
      flex: 0 0 33%;
      height: 100%;
      overflow-y: auto;
    }
    #right-content {
      display: -ms-flexbox;
      display: flex;
      -ms-flex-direction: column;
      flex-direction: column;
      -ms-flex: 1 1 0px;
      flex: 1 1 0px;
      height: 100%;
      overflow-y: auto;
    }
  `]
})
export class RecurrentTourComponent {

  @ViewChild(RecurrentTourListComponent) list: RecurrentTourListComponent;
  tourTemplate;

  onTourTemplateSelected = (tourTemplate) => {
    this.tourTemplate = tourTemplate;
  }

  onTourTemplateSaved = (tourTemplate) => {
    this.list.refresh();
  }
}



// WEBPACK FOOTER //
// ./src/app/recurrence/recurrent-tour.component.ts